import Stock from './Stock';

class Forecast extends Stock {
  public weekStartDate: Date;
}

export default Forecast;